import { COLORS } from 'core/constants';
import Copy from '@resn/gozer-core/copy';

export default {
    oxefit: {
        id: 'oxefit',
        tagline: Copy.get('oxefit-general-tagline'),
        img: null,
        color: COLORS.ORANGE,

        logoId: 'oxefit-logo',

        types: [
            {
                title: Copy.get('oxefit-subscription-title'),
                description: Copy.get('oxefit-subscription-subtitle'),
                features: [
                    Copy.get('oxefit-subscription-feature-1'),
                    Copy.get('oxefit-subscription-feature-2'),
                    Copy.get('oxefit-subscription-feature-3'),
                    Copy.get('oxefit-subscription-feature-4'),
                    Copy.get('oxefit-subscription-feature-5'),
                    Copy.get('oxefit-subscription-feature-6'),
                ],
            },
        ],

        info: [
            {
                type: 'price',
                title: Copy.get('oxefit-subscription-price-monthly'),
                subtitle: 'Monthly',
            },
        ],
    },

    oxelead: {
        id: 'oxelead',
        tagline: Copy.get('oxelead-general-tagline'),
        img: null,
        color: COLORS.LIGHT_BLUE,

        logoId: 'oxelead-logo',

        types: [
            {
                title: Copy.get('oxelead-subscription-trainers-title'),
                description: Copy.get('oxelead-subscription-trainers-subtitle'),
                features: [
                    Copy.get('oxelead-subscription-trainers-feature-1'),
                    Copy.get('oxelead-subscription-trainers-feature-2'),
                    Copy.get('oxelead-subscription-trainers-feature-3'),
                    Copy.get('oxelead-subscription-trainers-feature-4'),
                    Copy.get('oxelead-subscription-trainers-feature-5'),
                    Copy.get('oxelead-subscription-trainers-feature-6'),
                ],
            },
            {
                title: Copy.get('oxelead-subscription-rehab-title'),
                // description: Copy.get('oxelead-subscription-rehab-subtitle'),
                featureDescription: Copy.get('oxelead-subscription-rehab-features-description'),
                featuresTitle: Copy.get('oxelead-subscription-rehab-features-title'),
                features: [
                    Copy.get('oxelead-subscription-rehab-feature-1'),
                    Copy.get('oxelead-subscription-rehab-feature-2'),
                    Copy.get('oxelead-subscription-rehab-feature-3'),
                ],
            },
            {
                title: Copy.get('oxelead-subscription-organizations-title'),
                // description: Copy.get('oxelead-subscription-organizations-subtitle'),
                featureDescription: Copy.get('oxelead-subscription-organizations-features-description'),
                featuresTitle: Copy.get('oxelead-subscription-organizations-features-title'),
                features: [
                    Copy.get('oxelead-subscription-organizations-feature-1'),
                    Copy.get('oxelead-subscription-organizations-feature-2'),
                    Copy.get('oxelead-subscription-organizations-feature-3'),
                ],
            },
        ],

        info: [
            {
                type: 'title',
                title: '', //Copy.get('oxelead-subscription-info-title'), // REMOVE TITLE..
                subtitle: Copy.get('oxelead-subscription-info-subtitle'),
            },
            {
                type: 'link',
                text: Copy.get('oxelead-subscription-info-email'),
                link: `mailto:${Copy.get('oxelead-subscription-info-email')}`,
            },
            // {
            //     type: 'link',
            //     text: Copy.get('oxelead-subscription-info-phone'),
            //     link: Copy.get('oxelead-subscription-info-phone'),
            // },
        ],
    },
    oxelife: {
        id: 'oxelife',
        tagline: Copy.get('oxelife-general-tagline'),
        img: null,
        color: COLORS.VIOLET,

        logoId: 'oxelife-logo',
    },
};
